// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__dxiVk","author":"Table_author__3GgT8","authorImage":"Table_authorImage__13-ko","unreadRow":"Table_unreadRow__DhB5Z"};